// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t2-2";
export var container = "_t2-4";
export var dismissButton = "_t2-3";
export var hasPaddingBottom = "_t2-6";
export var last = "_t2-e";
export var scrollbarThumb = "_t2-c";
export var scrollbarTrack = "_t2-b";
export var selected = "_t2-9";
export var spin = "_t2-1";
export var spinning = "_t2-0";
export var suggestionItem = "_t2-d";
export var suggestionsPanel = "_t2-5";
export var tonePill = "_t2-8";
export var tonesContainer = "_t2-7";
export var unselected = "_t2-a";